<template>
  <div class="api-doc-container">
    <div class="doc-content">
      <h1>HERON6000 文档中心</h1>
      <nav class="doc-links">
        <router-link to="/doc/instruction">1、使用手册</router-link> 
        <router-link to="/doc/interface">2、接口文档</router-link>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocIndex',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  mounted() { },
  created() { },
  methods: {}
}
</script>

<style scoped>
.api-doc-container {
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background: #f8fafc; /* subtle background */
}

.doc-content {
  width: 100%;
  max-width: 720px;
  text-align: left; /* ensure lines are left-aligned */
}

h1 {
  margin: 0 0 16px;
  font-size: 28px;
  line-height: 1.3;
  color: #0f172a; /* slate-900 */
  font-weight: 700;
}

.doc-links {
  display: grid;
  gap: 10px;
}

.doc-links a {
  display: block;
  font-size: 18px;
  color: #334155; /* slate-700 */
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  transition: color .15s ease, box-shadow .15s ease, transform .05s ease;
}

.doc-links a:hover {
  color: #2563eb; /* blue-600 */
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  transform: translateY(-1px);
}
</style>
